/* ================================================== */
/* CAROUSEL
/* ================================================== */

function prevNext($prev, $next, prevCondition, nextCondition, index, total) {
	// Inits
	var disabled = 'carousel-nav-disabled';

	// Update
	(prevCondition(index, total)) ? $prev.addClass(disabled).attr('disabled', true) : $prev.removeClass(disabled).removeAttr('disabled');
	(nextCondition(index, total)) ? $next.addClass(disabled).attr('disabled', true) : $next.removeClass(disabled).removeAttr('disabled');
}

function setCarouselVideosHeight($carousel) {
	if ($carousel.data('type') == 'videos') {
		var maxHeight = 0;
		$.each($('.medias-assets-player', $carousel), function(index, element) {
			var height = $(element).width() * $(element).data('player-ratio');
			maxHeight = (height > maxHeight) ? height : maxHeight;
		});
		$('.flickity-viewport', $carousel).width('100%').height(maxHeight);
	}
}

$(document).ready(function() {
	$('.carousel').each(function(index, element) {
		var $carousel = $('.carousel-items', element),
			$nav = $('.carousel-as-nav-for', element),
			$prev = $('.carousel-nav-prev', element),
			$next = $('.carousel-nav-next', element),
			total = parseInt($carousel.data('total')),
			type = $carousel.data('type'),
			prevCondition = function prevCondition(index, total) { return index == 0; },
			nextCondition = function nextCondition(index, total) { return index + 1 == total; };

		// Ready
		$carousel.on('ready.flickity', function() {
			setCarouselVideosHeight($carousel);
			$(window).on('resize orientationchange', function() { setCarouselVideosHeight($carousel); });
			$carousel.addClass('ready');
		});

		$carousel.on('select.flickity', function(event, index) {
			prevNext($prev, $next, prevCondition, nextCondition, index, total);
		});

		// Inits | As nav for
		if ($(element).is('[data-type="as-nav-for"]')) {
			$nav.on('ready.flickity', function() {
				$nav.addClass('ready');
			});

			$carousel.flickity({
				cellAlign: 'left',
				fullscreen: (type == 'videos') ? false : true,
				hash: true,
				pageDots: (total > 1) ? true : false,
				percentPosition: true,
				prevNextButtons: false,
				setGallerySize: (type == 'videos') ? false : true
			});

			$nav.flickity({
				asNavFor: $carousel[0],
				pageDots: false,
				percentPosition: true,
				prevNextButtons: false
			});

		// Inits | Regular
		} else if (total > 1) {
			$carousel.flickity({
				cellAlign: 'left',
				pageDots: false,
				prevNextButtons: false
			});
		}

		// Events
		$carousel.on('change.flickity', function(event, index) {
			// Update counter
			$('.carousel-counter-current', element).html(index + 1);

			// Disable | Prev / Next
			prevNext($prev, $next, prevCondition, nextCondition, index, total);

			// Toggle video player
			if (type == 'videos') {
				$.each(players[index], function(i) {
					if (i !== index) {
						players[index].pause();
						players[index].setCurrentTime(0);
					}
				});
				players[index].play();
			}
		});

		// Click
		$prev.click(function(event) { $carousel.flickity('previous'); });
		$next.click(function(event) { $carousel.flickity('next'); });
	});
});